import { capitalizeAllWordsInSentence } from "../../controllers/common";
import { HUBS } from "./Constants";

export const HUBS_MAPPINGS = {
  [HUBS.BENGALURU]: "BLR",
  [HUBS.BENGALURU_CHILD_TESTING]: "BLR CT",
  [HUBS.DELHI]: "DEL",
  [HUBS.HYDERABAD]: "HYD",
  [HUBS.INDIA]: "India",
  [HUBS.MUMBAI]: "BOM",
  [HUBS.PUNE]: "PNQ",
  [HUBS.TEST_HUB]: "Test Hub",
  [HUBS.UBER_BLACK_DELHI_ESCROW]: "Uber Black Delhi Escrow",
  [HUBS.UBER_BLACK_MUMBAI]: "BOM (B)",
  [HUBS.HO]: "HO",
  [HUBS.UBER_BLACK_DELHI]: "DEL (B)",
  [HUBS.UBER_BLACK_BENGALURU]: "BLR (B)",
  [HUBS.KOLKATA]: "KOL",
  [HUBS.HYDERABAD_AIRPORT_TAXI]: "HYD (AT)",
  [HUBS.DELHI_AIRPORT_TAXI]: "DEL (AT)",
};

export const GET_MAPPED_HUB_NAME = (hubName) => {
  if (HUBS_MAPPINGS[hubName]) {
    return HUBS_MAPPINGS[hubName];
  }
  let name = hubName;
  name = capitalizeAllWordsInSentence(name);
  return name;
};
